const storeName = 'GLOBAL';
export default {
    ADD_GLOBAL_MESSAGE: `${storeName}.ADD_GLOBAL_MESSAGE`,
    SET_GLOBAL_MESSAGE: `${storeName}.SET_GLOBAL_MESSAGE`,
    SET_TEMPORARY_MESSAGE: `${storeName}.SET_TEMPORARY_MESSAGE`,
    ERASE_TEMPORARY_MESSAGE: `${storeName}.ERASE_TEMPORARY_MESSAGE`,
    ERASE_WITH_DELAY_TEMPORARY_MESSAGE: `${storeName}.ERASE_WITH_DELAY_TEMPORARY_MESSAGE`,
    SET_SITE: `${storeName}.SET_SITE`,
    SET_BASE_STORE: `${storeName}.SET_BASE_STORE`,
    SET_OCC_BASE_URI: `${storeName}.SET_OCC_BASE_URI`,
    SET_AVAILABLE_LANGUAGES: `${storeName}.SET_AVAILABLE_LANGUAGES`,
    SET_CURRENCY_CODE: `${storeName}.SET_CURRENCY_CODE`,
    VISITED: `${storeName}.VISITED`,
    BEFORE_RENDER: `${storeName}.BEFORE_RENDER`,
    PAGE_LOAD: `${storeName}.PAGE_LOAD`,
    PAGE_LOAD_EVENT_PUSHED: `${storeName}.PAGE_LOAD_EVENT_PUSHED`,
    GO_BACK: `${storeName}.GO_BACK`,
    REDIRECT: `${storeName}.REDIRECT`,
    GOTO: `${storeName}.GOTO`,
    REDIRECT_PAGE_SELECTORS: `${storeName}.REDIRECT_PAGE_SELECTORS`,
    RESET_FORMS_MESSAGES: `${storeName}.RESET_FORMS_MESSAGES`,
    SET_PREFERRED_LANGUAGE: `${storeName}.SET_PREFERRED_LANGUAGE`,
    SET_PREFERRED_COUNTRY: `${storeName}.SET_PREFERRED_COUNTRY`,
    SET_LANGUAGE: `${storeName}.SET_LANGUAGE`,
    SET_COUNTRY: `${storeName}.SET_COUNTRY`,
    SET_WISHLIST_MODE: `${storeName}.SET_WISHLIST_MODE`,
    SET_IMAGE_PLACEHOLDER_PATH: `${storeName}.SET_IMAGE_PLACEHOLDER_PATH`,
    UPDATE_COUNTRY: `${storeName}.UPDATE_COUNTRY`,
    UPDATE_LANGUAGE: `${storeName}.UPDATE_LANGUAGE`,
    DOM_CONTENT_LOADED: `${storeName}.DOM_CONTENT_LOADED`,
    APP_INIT: `${storeName}.APP_INIT`,
    DISABLE_TURBOLINKS: `${storeName}.DISABLE_TURBOLINKS`,
    CLOSE_LANGUAGE_DIALOG: `${storeName}.CLOSE_LANGUAGE_DIALOG`,
    CLOSE_COUNTRY_DIALOG: `${storeName}.CLOSE_COUNTRY_DIALOG`,
    OPEN_COOKIE_POPUP: `${storeName}.OPEN_COOKIE_POPUP`,
    FORM_INITIALIZE: `${storeName}.FORM_INITIALIZE`,
    SET_SUBMITTING: `${storeName}.SET_SUBMITTING`,
    ENTER_CLICKED: `${storeName}.ENTER_CLICKED`,
    CHANGE_LANGUAGE: `${storeName}.CHANGE_LANGUAGE`,
    SET_NESTED_LEVEL_DATA: `${storeName}.SET_NESTED_LEVEL_DATA`,
    TOGGLE_FLASH_MESSAGE: `${storeName}.TOGGLE_FLASH_MESSAGE`,
    SET_FLASH_MESSAGE_GROUP: `${storeName}.SET_FLASH_MESSAGE_GROUP`,
    SET_LAST_TIME_PAGE_LOAD: `${storeName}.SET_LAST_TIME_PAGE_LOAD`,
    ADD_MESSAGE: `${storeName}.ADD_MESSAGE`,
    REMOVE_MESSAGE: `${storeName}.REMOVE_MESSAGE`,
    REMOVE_ALL_MESSAGES: `${storeName}.REMOVE_ALL_MESSAGES`,
    REMOVE_MESSAGE_WITH_DELAY: `${storeName}.REMOVE_MESSAGE_WITH_DELAY`,
    UPDATE_MESSAGE: `${storeName}.UPDATE_MESSAGE`,
    SET_PREV_PAGE_DATA: `${storeName}.SET_PREV_PAGE_DATA`,
    SET_ORIGIN_ACTION: `${storeName}.SET_ORIGIN_ACTION`,
    TRACK_LOAD_PAGE: `${storeName}.TRACK_LOAD_PAGE`,
    OPEN_URL: `${storeName}.OPEN_URL`,
    SET_DELIVERY_COUNTRY: `${storeName}.SET_DELIVERY_COUNTRY`,
    SET_DELIVERY_COUNTRY_ON_LOAD: `${storeName}.SET_DELIVERY_COUNTRY_ON_LOAD`,
    GET_STORE_CONFIG: `${storeName}.GET_STORE_CONFIG`,
    SET_STORE_CONFIG: `${storeName}.SET_STORE_CONFIG`,
    SET_BR_CATALOG_NAME: `${storeName}.SET_BR_CATALOG_NAME`,
    SET_GLOBAL_PAGE_INFO: `${storeName}.SET_GLOBAL_PAGE_INFO`,
    SET_THRESHOLD_CONFIGURATION: `${storeName}.SET_THRESHOLD_CONFIGURATION`,
};
